<template>
<CustomField
  v-bind="$props"
>
  <VueSelect
    v-bind="$attrs"
    class="custom-select"
    v-on="$listeners"
  />
</CustomField>
</template>

<script>
import VueSelect from 'vue-select';
import CustomField from './CustomField'

export default {
  inheritAttrs: false,

  components: { VueSelect, CustomField },

  props: {
    // Same props as in CustomField, so we can pass them to CustomField, and pass `$attrs` to the input.
    id: {}, label: {}, error: {},
  },
}
</script>
